import React from "react";
import { useNavigate } from "react-router-dom";
// contents
export const useGoContents = (type : number) => {
    const navi = useNavigate()
    return (e:React.MouseEvent) => {
        e.preventDefault(); navi(`/contents/${type}`)
    }
}